import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import { Link } from "react-router-dom";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { LanguageConstants } from "../../constants/LanguageConstants";
import Swal from 'sweetalert2'
import FrontLoader from "../layout/FrontLoader";
import { Modal } from "react-bootstrap";
import UpdateAddress from "../../Modal/UpdateAddress";

const AddressList = () => {
  const List = useMakeRequest()
  const deleteAddress = useMakeRequest()
  const [show , setShow] = useState(false)
  const [details , setDetails] = useState({})

const [data , setData] = useState([])
  useEffect(() => {
    List.makeRequest({url: ApiConstants?.AddressList, toastStatus: false })
  }, [deleteAddress.status])

  useEffect(()=>{
  if(List?.status){
  setData(List?.data?.data?.rows)  
  }
  },[List.status])

  const handelDelete =(id:any)=>{
      Swal.fire({
        title: LanguageConstants?.ARE_YOU_SURE,
        text: LanguageConstants?.YOU_WANT_TO_DELETE_Address,
        icon: 'warning',
        // showCancelButton: true,
        confirmButtonColor: '#31CE36',
        cancelButtonColor: '#d33',
        showDenyButton: true,
        denyButtonText: 'No',
        confirmButtonText: LanguageConstants?.YES,
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const payload ={
            address_id:id
          }
          deleteAddress.makeRequest({ payload, url: ApiConstants?.AddressDelete, toastStatus: true })
        }
      });
  }

  const handleUpdate =(data:any)=>{
    setShow(true)
    setDetails(data)
  }
  
  return (
    <>
    {List.loading || deleteAddress?.loading ? <FrontLoader/> : null}   
        {/* top banner section start */}
        <section
          className="main-banner small-banner"
          style={{ background: `url(${profileBanner}) center/cover` }}
        >
          <div className="container">
            <h1 className="small-banner-heading">{LanguageConstants?.MYADDRESS}</h1>
          </div>
        </section>
        {/* top banner section end  */}
        <div className="footer-space">
            <div className="container">
            
               <ul className="my-address-list">
               {data?.length > 0 ? 
    (
        data?.map((res:any , i:any) => (
            <li className="address-item" key={i}>
                <span>
                   {res?.street_line},{res?.zip_code}
                </span>
                <div className="d-flex gap-3 ms-auto">
                  <button type="button" onClick={()=>handleUpdate(res)}  className="delete-address border-success">
                      <i className="icon-edit-profile text-success"></i>
                  </button>
                  <button type="button" onClick={()=>handelDelete(res?.id)}  className="delete-address">
                      <i className="icon-delete"></i>
                  </button>
                </div>
            </li>
        ))
    ) : (
        <p className="text-center mt-3">{LanguageConstants?.DATANOTFOUND}</p>
    )
}     
               </ul>
            </div>
        </div>
      <Modal show={show}  >
          <UpdateAddress setShow={setShow} data={details} />
      </Modal>
    </>
  );
};

export default AddressList;
